import { render } from "./new_fence.vue?vue&type=template&id=3dffe938&scoped=true"
import script from "./new_fence.vue?vue&type=script&lang=js"
export * from "./new_fence.vue?vue&type=script&lang=js"

import "./new_fence.vue?vue&type=style&index=0&id=3dffe938&scoped=true&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dffe938"]])

export default __exports__